import { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { BiSolidError } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { IoCloseSharp } from "react-icons/io5";
import { RiDeleteBin6Fill } from "react-icons/ri";
import "react-loading-skeleton/dist/skeleton.css";
import ReactPaginate from "react-paginate";
import { NavLink } from "react-router-dom";
import SkeletonLoading from "../../component/SkeletonLoading";
import { useTranslation } from "react-i18next";

const UserActivityLogs = () => {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([
    {
      id: 1,
      user: "admin@school.com",
      action: "Login",
      timestamp: "2025-05-26 10:15",
    },
    {
      id: 2,
      user: "john@school.com",
      action: "Changed role to Moderator",
      timestamp: "2025-05-25 17:30",
    },
    {
      id: 3,
      user: "admin@school.com",
      action: "Logout",
      timestamp: "2025-05-25 18:00",
    },
  ]);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [email, setEmail] = useState();

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [perPage, SetcurrentPage] = useState(10);

  const handleShow = (key) => (key === "show" ? setShow(true) : setShow2(true));
  const handleClose = (key) =>
    key === "show" ? setShow(false) : setShow2(false);

  return (
    <>
      <div className="dbCon">
        <div className="dbRight">
          <div>
            <div className="d-flex flex-wrap align-items-center justify-content-start">
              <div className="mb-2 total">
                {/* Total Drivers: 1 */}
                {/* {driverList?.pagination_data?.total} */}
              </div>
              <div className="mb-2 filterBox justify-content-start align-items-start PlansPaymentCss">
                <li>
                  <div className="d-flex">
                    <input
                      type="text"
                      className="formInput plans-field me-2"
                      placeholder={`${t("search")} ${t("by")} ${t("email")}`}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button className="btn btn-primary me-2">
                      {t("search")}
                    </button>
                  </div>
                </li>
              </div>
            </div>
            <div className="table m-0">
              <table>
                <thead>
                  <tr>
                    <th>
                      <span className="align-items-center d-flex gap-3">
                        <input type="checkbox" />
                        {t("srNo")}
                      </span>
                    </th>
                    <th>{t("user")}</th>
                    <th>{t("action")}</th>
                    <th>{t("timestamp")}</th>
                  </tr>
                </thead>
                <tbody>
                  {false ? (
                    <SkeletonLoading length={6} />
                  ) : (
                    logs.map((log, index) => (
                      <tr key={log.id}>
                        <td>
                          <span className="align-items-center d-flex gap-3">
                            <input type="checkbox" />
                            {index + 1}
                          </span>
                        </td>
                        <td>{log.user}</td>
                        <td>{log.action}</td>
                        <td>{log.timestamp}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="paginationCss d-flex justify-content-between align-items-center p-3">
              {/* Left Section */}
              <div className="d-flex school-footer align-items-center gap-3">
                <button className="btn btn-dark btn-showall">
                  {t("show")} {t("all")}
                </button>
              </div>

              {/* Right Section: Pagination */}
              <nav>
                <ul className="pagination mb-0">
                  <li className="page-item">
                    <a className="page-link" href="/admin-venders">
                      &laquo;
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link" href="/admin-venders">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="/admin-venders">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="/admin-venders">
                      &raquo;
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show}>
        <Button className="closePopup" onClick={() => handleClose("show")}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          <div>
            <div className="text-center mb-3 errorIcon">
              <BiSolidError />
            </div>
            <div className="text-center mb-4 deleteHd">
              {t("confirmDelete")}
            </div>
            <div className="text-center">
              <Button
                className="smallBtn cancel me-3"
                onClick={() => handleClose("show")}
              >
                {t("btns.cancel")}
              </Button>
              <Button className="smallBtn auto">
                {false ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("btns.delete")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal show={show2}>
        <Button className="closePopup" onClick={() => handleClose("show2")}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          {/* style={{ display: visible ? "none" : "block" }} */}
          <div>
            <h2 className="text-center fpHd mb-3">{t("verification")}</h2>
            <ul className="form p-0 m-0">
              <li>
                <label className="filedHd">{t("name")}</label>
                <select
                  //   value={status}
                  //   onChange={(e) => setStatus(e.target.value)}
                  className="formSelect"
                >
                  <option>{t("pending")}</option>
                  <option>{t("verified")}</option>
                  <option>{t("rejected")}</option>
                </select>
              </li>
              <li>
                <label className="filedHd">{t("comment")}</label>
                <textarea
                  className="formInput"
                  placeholder="Description"
                  //   value={description}
                  //   onChange={(e) => setDescription(e.target.value)}
                />
              </li>

              <li className="d-flex">
                <div className="col-6 pe-2 pt-2">
                  <Button
                    className="smallBtn full cancel"
                    onClick={() => handleClose("show2")}
                  >
                    {t("btns.cancel")}
                  </Button>
                </div>
                <div className="col-6 ps-2 pt-2">
                  <Button
                    className="smallBtn full"
                    // onClick={() => setVisible(!visible)}
                  >
                    {t("btns.submit")}
                  </Button>
                </div>
              </li>
            </ul>
          </div>
          {/* <div style={{ display: visible ? "block" : "none" }}>
            <div className="text-center mb-3 checkIcon">
              <IoMdCheckboxOutline />
            </div>
            <div className="text-center mb-3 deleteHd">
              Vendor Added Successfully!
            </div>
            <div className="text-center mb-4">
              New vendor details have been added.
            </div>
            <div className="text-center">
              <Button
                className="smallBtn cancel me-3"
                onClick={handleModalClose}
              >
                Close
              </Button>
            </div>
          </div> */}
        </div>
      </Modal>
    </>
  );
};

export default UserActivityLogs;
